/*
 * @Autor: Baowang
 * @Date: 2024-11-07 09:13:28
 * @pageName: 路由配置
 * @LastEditTime: 2024-11-08 18:56:39
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import pageHome from '../views/pageHome.vue'//主页
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'pageHome',
    component: pageHome
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
